import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { createSelector } from "reselect";
import SelectDateMenu from "../../components/SelectDateMenu/SelectDateMenu";
import NavMenu from "../../components/NavMenu";
import { BLUE_RGB } from "../../utils/colorsTheme";
import {
  getPipes,
  changeStation,
  changeStartDate,
  changeEndDate,
  setError,
  setConfigTab,
} from "../../redux/ducks/pipesSeries";
import { Details } from "./Details";
import { AcumSeries } from "./AcumSeries";

dayjs.extend(isSameOrBefore);

const startDateSelector = createSelector(
  (state) => state.pipesSeries.startDate,
  (startDate) => (startDate ? dayjs(startDate) : dayjs())
);
const endDateSelector = createSelector(
  (state) => state.pipesSeries.endDate,
  (endDate) => (endDate ? dayjs(endDate) : dayjs())
);

const configTabs = [
  { id: "001", label: "Detalle", page: <Details /> },
  { id: "002", label: "Acumulado", page: <AcumSeries /> },
];

export default function PipesSeries() {
  const dispatch = useDispatch();

  const { tab } = useSelector((state) => state.pipesSeries.config);
  const { stationsList: stations } = useSelector((state) => state.companies);
  const stationSelected = useSelector(
    (state) => state.pipesSeries.stationSelected
  );
  const startDate = useSelector((state) => startDateSelector(state));
  const endDate = useSelector((state) => endDateSelector(state));

  const fetchPipes = useCallback(
    (stations, startDate, endDate) => {
      dispatch(getPipes(stations, startDate, endDate));
    },
    []
  );

  const handleChangeTabMemoized = useCallback(
    (event, newValue) => {
      dispatch(setConfigTab(newValue));
    },
    []
  );

  const handleChangeTabIndexMemoized = useCallback(
    (index) => {
      dispatch(setConfigTab(index));
    },
    []
  );

  const changeStationMemoized = useCallback(
    (station) => {
      dispatch(changeStation(station));
    },
    []
  );

  const changeStartDateMemoized = useCallback(
    (date) => {
      dispatch(changeStartDate(dayjs(date).format("YYYY-MM-DD")));
    },
    []
  );

  const changeEndDateMemoized = useCallback(
    (date) => {
      dispatch(changeEndDate(dayjs(date).format("YYYY-MM-DD")));
    },
    []
  );

  const setSnackbar = useCallback((error) => {
    dispatch(setError(error));
  }, []);

  const handleSubmit = () => {
    if (!startDate) {
      setSnackbar("No se ha seleccionado fecha de inicio.");
      return;
    }
    if (!endDate) {
      setSnackbar("No se ha seleccionado fecha final.");
      return;
    }
    if (!stationSelected) {
      setSnackbar("No se ha seleccionado alguna planta.");
      return;
    }
    if (!dayjs(startDate).isSameOrBefore(dayjs(endDate), "day")) {
      setSnackbar("La fecha final no puede ser menor a la inicial.");
      return;
    }
    if (dayjs(endDate).diff(dayjs(startDate), "day") > 7) {
      setSnackbar("El lapso entre fechas no puede ser mayor a 7 días.");
      return;
    }
    const start = dayjs(startDate).format("YYYY-MM-DD");
    const end = dayjs(endDate).format("YYYY-MM-DD");
    fetchPipes(stationSelected, start, end);
  };

  return (
    <React.Fragment>
      <SelectDateMenu
        onChangeStartDate={changeStartDateMemoized}
        onChangeEndDate={changeEndDateMemoized}
        stations={stations}
        isMultiOne={true}
        dates={{ startDate, endDate }}
        optionSelected={stationSelected}
        onChangeFilter={changeStationMemoized}
        hasStations
        onSubmit={handleSubmit}
        color="info"
      />
      <NavMenu
        value={tab}
        onChange={handleChangeTabMemoized}
        onChangeIndex={handleChangeTabIndexMemoized}
        color={BLUE_RGB}
        configTabs={configTabs}
      />
    </React.Fragment>
  );
}
